import type { PropsWithChildren } from "react";

import { cn } from "~/lib/utils";

const COLUMN_CLASS: Record<2 | 3 | 4, string> = {
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4"
};

export type UserGridProps = PropsWithChildren<{
  columns?: 2 | 3 | 4;
  className?: string;
}>;

/**
 * Grid container for {@link UserCard}s. A 1px gap over a neutral background
 * renders hairline separators between cells, and the rounded, clipped corners
 * keep the outer edge tidy.
 */
export const UserGrid = ({
  columns = 3,
  children,
  className
}: UserGridProps) => (
  <div
    className={cn(
      "grid gap-px overflow-hidden rounded-2xl border border-interface-neutral-3 bg-interface-neutral-3",
      COLUMN_CLASS[columns],
      className
    )}
  >
    {children}
  </div>
);
